import { render, staticRenderFns } from "./AppAnnotationPart4.vue?vue&type=template&id=4cf8bf82&scoped=true"
import script from "./AppAnnotationPart4.vue?vue&type=script&lang=ts"
export * from "./AppAnnotationPart4.vue?vue&type=script&lang=ts"
import style0 from "./AppAnnotationPart4.vue?vue&type=style&index=0&id=4cf8bf82&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cf8bf82",
  null
  
)

export default component.exports